import classNames from "classnames";
import Switch from "react-switch";
import { RemovingThrobber } from "../../removing_throbber";
import { SettingsBaseItem } from "./settings_base_item";

export function SettingsBooleanItem(props: {
	label: string;
	description?: string | JSX.Element;
	value: boolean;
	is_loading: boolean;
	disabled?: boolean;
	is_premium?: boolean;
	is_beta?: boolean;
	onChange: (checked: boolean) => void;
}) {
	return (
		<SettingsBaseItem {...props}>
			<div className="flex w-fit items-center gap-2">
				<span
					aria-hidden={!props.is_loading}
					className={classNames("flex", {
						invisible: !props.is_loading,
						visible: props.is_loading,
					})}
				>
					<RemovingThrobber />
				</span>
				<Switch
					// height={24}
					disabled={props.disabled || props.is_loading}
					checked={props.value}
					onChange={props.onChange}
					onColor="#00c3cc"
					onHandleColor="#00f4ff"
					checkedIcon={
						<span className="flex h-full flex-col items-center justify-center text-black opacity-50">
							<i className="fas fa-check"></i>
						</span>
					}
					uncheckedIcon={
						<span className="flex h-full flex-col items-center justify-center text-black opacity-50">
							<i className="fas fa-times"></i>
						</span>
					}
				/>
			</div>
		</SettingsBaseItem>
	);
}
